import React from "react";
import OptionType from "features/shared/components/selectInput/OptionType";
import SelectInput from "features/shared/components/selectInput/SelectInput";

interface Props {
  startMonth?: number;
  endMonth?: number;
  selectedMonth?: number;
  name?: string;
  className?: string;
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
}

const MonthSelect = ({
  startMonth = 1,
  endMonth = 12,
  selectedMonth,
  name,
  className,
  onChange,
}: Props) => {
  // helpers
  const generateMonths = (): OptionType[] => {
    let result: OptionType[] = [];

    for (let i = startMonth; i <= endMonth; i++) {
      result.push({
        value: String(i),
        name: String(i),
      });
    }

    return result;
  };

  // render
  return (
    <div className={className}>
      <SelectInput
        name={name ?? "monthSelect"}
        options={generateMonths()}
        value={selectedMonth}
        onChange={onChange}
        className="mb-0"
      />
    </div>
  );
};

export default MonthSelect;
